import React, { ReactNode } from 'react'

interface ChartWrapperProps {
  title: string
  children: ReactNode
  className?: string
  height?: number
  loading?: boolean
}

export function ChartWrapper({
  title,
  children,
  className = '',
  height,
  loading = false,
}: ChartWrapperProps) {
  return (
    <div className={`card border-0 shadow-sm h-100 ${className}`}>
      <div className="card-header bg-white border-bottom-0 pt-4 pb-2">
        <h5 className="card-title mb-0 fw-bold">{title}</h5>
      </div>
      <div
        className="card-body p-3 position-relative"
        style={{ minHeight: height || 350 }}
      >
        {loading && (
          <div
            className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
            style={{ zIndex: 10, backgroundColor: 'rgba(255,255,255,0.7)' }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  )
}
